import { useShallow } from 'zustand/react/shallow';
import { useWheelStore, type WheelState } from '@store/wheelStore';

/**
 * useWheelData(selector) — subscribe to a specific slice of wheel state.
 *
 * Each component should select only the fields it uses so unrelated state
 * changes elsewhere in the store do not cause unnecessary re-renders.
 *
 * Examples:
 *   const { winner, winnerInfo } = useWheelData(s => ({ winner: s.winner, winnerInfo: s.winnerInfo }));
 *   const handleSpin = useWheelData(s => s.handleSpin);
 *   const wheelState = useWheelData(s => s.wheelState);
 */
export function useWheelData<T>(selector: (state: WheelState) => T): T {
  return useWheelStore(useShallow(selector));
}
